import './styles.scss'

import { Col, Row } from 'antd'

import B2becOverviewGuideBlock from '@/components/B2becOverviewGuideBlock'
import { B2BEC_OVERVIEWGUIDE_TYPES } from '@/components/B2becOverviewGuideBlock/overview-guide-block.constants'
import PermissionWrapper from '@/HOCs/permissionWrapper'
import { MODULE_MACHINE_RIGHTS, MODULE_ORDER_RIGHTS, MODULE_SHOP_NAVIGATION_RIGHTS } from '@/libs/constants/modulerights'

const OverviewGuide = () => {
  return (
    <div className="overview-guide">
      <Row gutter={[24, 24]}>
        <PermissionWrapper permission={MODULE_MACHINE_RIGHTS.VIEW_MACHINE_LIST}>
          <Col lg={8} span={24}>
            <B2becOverviewGuideBlock
              type={B2BEC_OVERVIEWGUIDE_TYPES.MY_MACHINES}
            />
          </Col>
        </PermissionWrapper>
        <PermissionWrapper permission={MODULE_ORDER_RIGHTS.VIEW_ORDER_HISTORY}>
          <Col lg={8} span={24}>
            <B2becOverviewGuideBlock type={B2BEC_OVERVIEWGUIDE_TYPES.MY_ORDERS} />
          </Col>
        </PermissionWrapper>
        <PermissionWrapper permission={MODULE_SHOP_NAVIGATION_RIGHTS.USE_PRODUCT_NAVIGATION}>
          <Col lg={8} span={24}>
            <B2becOverviewGuideBlock type={B2BEC_OVERVIEWGUIDE_TYPES.PRODUCTS} />
          </Col>
        </PermissionWrapper>
      </Row>
    </div>
  )
}

export default OverviewGuide
